import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getMerchantPaymentDetailByTransactionProvisionSettleGuid = guid =>get(url.MERCHANT_PAYMENT_DETAIL_BY_TRANSACTION_PROVISION_SETTLE_GUID_GET,{ params: { guid } })